import React from "react";
import "../all css/missionsection.css";
const mission_img = require("../../assets/aboutexplore/mission_bg.png");
const mission_rocket_img = require("../../assets/aboutexplore/fly_rocket.svg");
const mission_rocket_img1 = require("../../assets/aboutexplore/rocket_img.svg");

function MissionSection(props) {
  return (
    <div className="main_mission_container">
      <div className="mission_under_main_container">
        <div className="mission_header_container">
          <div className="mission_header_under_img_container">
            <div className="mission_img_container">
              <img
                className="mission_img"
                alt="mission_img"
                src={mission_img}
              />

              <div className="mission_text_title_container">
                <div className="mission_grey_img_rectangle" />
                <p className="mission_text_title wow pulse animated" 
                 data-wow-delay="500ms"
                 data-wow-iteration="infinite"
                 data-wow-duration="1s"
                >
                  OUR <br /> MISSION
                </p>
              </div>
            </div>
          </div>

          <div className="mission_rocket_img_container">
            <img
              src={mission_rocket_img.default}
              alt="mission_rocket_img"
              className="mission_rocket_img1"
            />
          </div>

          <div className="mission_content_heading_contianer">
            <div className="mission_four_box_container">
              <div className="mission_each_box_contianer wow bounceInLeft center">
              
                <p className="mission_box_sub_heading_text_white">
                Enabling International Mobility through <span className="highlight_about_us_content">Study, Work, and Migration</span>{" "}
                </p>
              </div>
              <div className="mission_each_box_contianer2 wow bounceInRight center">
                
                <p className="mission_box_sub_heading_text">
                To <span className="highlight_about_us_content">empower students</span> in decision making. We will lead the future of study abroad globally by offering the right choices, 
                for a successful career, made the right way.{" "}
                </p>
              </div>

              <div className="mission_each_box_contianer2 wow bounceInLeft center">
               
                <p className="mission_box_sub_heading_text">
                To offer a <span className="highlight_about_us_content">personalised approach</span> to help aspiring students explore, discover and gain admission into the <span className="highlight_about_us_content">top universities</span> across the world.{" "}
                </p>
              </div>

              <div className="mission_each_box_contianer wow bounceInRight center">
                
                <p className="mission_box_sub_heading_text_white">
                To become the <span className="highlight_about_us_content">number one</span> destination for study abroad information and make it <span className="highlight_about_us_content">universally accessible</span> and useful.{" "}
                </p>
              </div>
            </div>
            <div className="mission_rocket_img1_container">
              <img
                src={mission_rocket_img1.default}
                alt="mission_rocket_img"
                className="mission_rocket_img2"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default MissionSection;
